import { useEffect, useRef } from 'react';

import { DashboardStep } from '@/features/dashboard/constants/DashboardStep';
import { useDashboardEditLockContext } from '@/features/dashboard/state/DashboardEditLockContext';

export const useDashboardStepControl = (step: DashboardStep) => {
  const { releaseEditLock } = useDashboardEditLockContext();
  const prevStepRef = useRef(step);

  useEffect(() => {
    return () => {
      releaseEditLock();
    };
  }, [releaseEditLock]);

  useEffect(() => {
    if (prevStepRef.current === DashboardStep.Edit && step !== DashboardStep.Edit) {
      releaseEditLock();
    }
    prevStepRef.current = step;
  }, [step, releaseEditLock]);
};
